export type BrowserAppRoute =
  | { readonly kind: "live" }
  | { readonly kind: "demo"; readonly operator: boolean };

export function resolveBrowserAppRoute(pathname: string): BrowserAppRoute {
  const normalizedPath =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

  if (normalizedPath === "/demo/operator") {
    return { kind: "demo", operator: true };
  }
  if (normalizedPath === "/demo") {
    return { kind: "demo", operator: false };
  }
  return { kind: "live" };
}
